import React from 'react';
import '../../../styles/global.css';

function ComputerVisionProjects() {
  return (
    <div className="body-container">
      <h1>Computer Vision & Computational Photography Projects</h1>
      <h4>Aug 2021 - Dec 2021</h4>
      <h2>Explore the projects <a href='https://tangmonica.github.io/cs194-26/' target="_blank" rel="noopener noreferrer">here</a>.</h2>
      <p>Projects in Python that utilize computer vision and image processing techniques, such as image pyramids, transformations, neural networks, etc.</p>
    </div>
  );
};

export default ComputerVisionProjects;
